module.exports = __webpack_public_path__ + "bg2.png?bba3f4417ecd8c10c123601d0409838c";


//////////////////
// WEBPACK FOOTER
// ./static/assets/bg2.png
// module id = 526
// module chunks = 0